// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Таблица === */

.HistoryPage_tableWrapper__97\\+wu {
  overflow-x: auto;
  max-height: calc(100vh - 240px);
  overflow-y: auto;
  padding-right: 6px;
}

.HistoryPage_table__59yph {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  font-size: 13px;
}

.HistoryPage_table__59yph th {
  background: #f5f6fa;
  text-align: left;
  padding: 8px 10px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
}

.HistoryPage_table__59yph td {
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f0;
  color: #444;
  vertical-align: top;
}

.HistoryPage_table__59yph tr:hover {
  background: #fafafa;
}

.HistoryPage_addr__4SoXE {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
}

/* === Бейдж статуса квитанции === */

.HistoryPage_statusBadge__2dML9 {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  border: 1px solid transparent;
}

/* классы для маппинга статусов (лучше в JS сделать switch и вернуть одну из этих строк) */
.HistoryPage_status_open__raNZi {
  background: #e8f5e9;
  color: #2e7d32;
  border-color: #a5d6a7;
}

.HistoryPage_status_closed__krWF4 {
  background: #e8f5e9;
  color: #2e7d32;
  border-color: #a5d6a7;
}

.HistoryPage_status_failed__zxlW- {
  background: #ffebee;
  color: #c62828;
  border-color: #ef9a9a;
}

/* === Бейдж переноса / критичность === */

.HistoryPage_movesBadge__HBu22 {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  border: 1px solid transparent;
  margin-bottom: 2px;
}

.HistoryPage_movesZero__r50fI {
  background: #eceff1;
  color: #455a64;
  border-color: #cfd8dc;
}

.HistoryPage_movesLow__xUE0T {
  background: #fff8e1;
  color: #f9a825;
  border-color: #ffe082;
}

.HistoryPage_movesMedium__L1FRv {
  background: #ffe0b2;
  color: #ef6c00;
  border-color: #ffb74d;
}

.HistoryPage_movesHigh__2Qh4- {
  background: #ffebee;
  color: #c62828;
  border-color: #ef9a9a;
  animation: HistoryPage_blinkHigh__4NIIu 1.4s infinite;
}

@keyframes HistoryPage_blinkHigh__4NIIu {
  0%   { box-shadow: 0 0 0 rgba(198, 40, 40, 0.0); }
  50%  { box-shadow: 0 0 10px rgba(198, 40, 40, 0.8); }
  100% { box-shadow: 0 0 0 rgba(198, 40, 40, 0.0); }
}

.HistoryPage_duration__\\+BGdW,
.HistoryPage_durationInline__1adiL {
  font-size: 11px;
  color: #666;
}

/* === Переключатели и фильтры === */

.HistoryPage_viewSwitch__DwWeM {
  display: flex;
  gap: 6px;
  margin-left: 10px;
}

.HistoryPage_switchBtn__K0OZr {
  background: #f9fafc;
  border: 1px solid #cbd3e1;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.HistoryPage_switchBtn__K0OZr:hover {
  background: #e8eaf6;
}

.HistoryPage_switchBtn__K0OZr.HistoryPage_active__moK0U {
  background: #3f51b5;
  color: #fff;
  border-color: #3f51b5;
}

.HistoryPage_filterRow__KHXhF {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 10px;
}

.HistoryPage_select__FuEQ5 {
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid #cbd3e1;
  font-size: 13px;
  background: #fff;
}

/* === Карточки: сетка, две колонки внутри === */

.HistoryPage_cardsWrapper__HZsdI {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 12px;
  max-height: calc(100vh - 240px);
  overflow-y: auto;
  padding-right: 6px;
}

.HistoryPage_card__pJKgM {
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  transition: all 0.2s ease;
  font-size: 13px;
}

.HistoryPage_card__pJKgM:hover {
  transform: translateY(-2px);
  box-shadow: 0 3px 8px rgba(0,0,0,0.15);
}

.HistoryPage_cardHeader__NshLg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.HistoryPage_cardNumber__TwcLl {
  font-weight: 700;
  color: #1565c0;
  text-decoration: none;
}

.HistoryPage_cardSubHeader__3Z71g {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.HistoryPage_cardGrid__ShS2u {
  display: grid;
  grid-template-columns: 1.4fr 1.2fr;
  gap: 10px;
  margin-top: 4px;
}

.HistoryPage_cardColLeft__7AhIr,
.HistoryPage_cardColRight__66wyO {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.HistoryPage_cardBody__k2j9V {
  color: #444;
}

.HistoryPage_row__8fSVO {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #333;
  font-size: 13px;
}

/* === Продукты === */

.HistoryPage_products__EEUyl {
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px solid #e0e0e0;
}

.HistoryPage_productItem__rjs4p {
  font-size: 12px;
  padding: 1px 0;
  color: #555;
}

.HistoryPage_productsMore__Aecux {
  font-size: 12px;
  margin-top: 2px;
  color: #888;
  font-style: italic;
}

/* === Таймлайн справа === */

.HistoryPage_historyTitle__fl0aJ {
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 4px;
  color: #333;
}

.HistoryPage_timeline__4oIZB {
  border-left: 2px solid #cbd3e1;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.HistoryPage_timelineItem__xz-ge {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.HistoryPage_timelineDot__DX-ai {
  position: absolute;
  left: -12px;
  top: 5px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #3f51b5;
}

/* цвет первого, второго и остальных маршрутов */
.HistoryPage_timelineFirst__Leklt {
  background: #43a047;   /* зелёный */
}

.HistoryPage_timelineSecond__ttB3l {
  background: #ffb300;   /* жёлтый */
}

.HistoryPage_timelineOther__t4EWd {
  background: #e53935;   /* красный */
}

.HistoryPage_timelineContent__k-1Ov {
  background: #fafafa;
  border-radius: 6px;
  padding: 4px 8px;
  border: 1px solid #e0e0e0;
}

.HistoryPage_timelineHeader__GMYoi {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.HistoryPage_timelineRoute__mNldX {
  font-weight: 600;
  color: #333;
}

.HistoryPage_timelineTime__JtOGu {
  font-size: 11px;
  color: #757575;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.HistoryPage_timelineAction__ghUgd {
  font-size: 12px;
  color: #555;
  margin-top: 2px;
}

.HistoryPage_timelineMeta__h87-f {
  font-size: 11px;
  color: #777;
  margin-top: 1px;
}

/* === Пагинация === */

.HistoryPage_pagination__dkT2Z {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
  font-size: 13px;
}

.HistoryPage_pagination__dkT2Z button {
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #cbd3e1;
  background: #f9fafc;
  cursor: pointer;
  transition: all 0.2s ease;
}

.HistoryPage_pagination__dkT2Z button:hover:not(:disabled) {
  background: #e8eaf6;
}

.HistoryPage_pagination__dkT2Z button:disabled {
  opacity: 0.4;
  cursor: default;
}

/* === Ошибки / пустота / загрузка === */

.HistoryPage_error__h2Sr4 {
  margin: 8px 0;
  padding: 6px 10px;
  background: #ffebee;
  color: #c62828;
  border-radius: 4px;
  font-size: 13px;
}

.HistoryPage_noData__6UScS,
.HistoryPage_loading__erqD5 {
  color: #444;
  font-size: 14px;
  text-align: center;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/HistoryReceipts/HistoryPage.module.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,oCAAoC;;AAEpC;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,0FAA0F;AAC1F;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,yCAAyC;;AAEzC;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,qDAAkC;AACpC;;AAEA;EACE,OAAO,wCAAwC,EAAE;EACjD,OAAO,2CAA2C,EAAE;EACpD,OAAO,wCAAwC,EAAE;AACnD;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA,oCAAoC;;AAEpC;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA,gDAAgD;;AAEhD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA,qBAAqB;;AAErB;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA,4BAA4B;;AAE5B;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,mBAAmB,IAAI,YAAY;AACrC;;AAEA;EACE,mBAAmB,IAAI,WAAW;AACpC;;AAEA;EACE,mBAAmB,IAAI,YAAY;AACrC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,sBAAsB;;AAEtB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,wCAAwC;;AAExC;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* === Таблица === */\r\n\r\n.tableWrapper {\r\n  overflow-x: auto;\r\n  max-height: calc(100vh - 240px);\r\n  overflow-y: auto;\r\n  padding-right: 6px;\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 1px 3px rgba(0,0,0,0.08);\r\n  font-size: 13px;\r\n}\r\n\r\n.table th {\r\n  background: #f5f6fa;\r\n  text-align: left;\r\n  padding: 8px 10px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.table td {\r\n  padding: 8px 10px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n  color: #444;\r\n  vertical-align: top;\r\n}\r\n\r\n.table tr:hover {\r\n  background: #fafafa;\r\n}\r\n\r\n.addr {\r\n  font-size: 12px;\r\n  color: #666;\r\n  margin-top: 2px;\r\n}\r\n\r\n/* === Бейдж статуса квитанции === */\r\n\r\n.statusBadge {\r\n  display: inline-block;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n/* классы для маппинга статусов (лучше в JS сделать switch и вернуть одну из этих строк) */\r\n.status_open {\r\n  background: #e8f5e9;\r\n  color: #2e7d32;\r\n  border-color: #a5d6a7;\r\n}\r\n\r\n.status_closed {\r\n  background: #e8f5e9;\r\n  color: #2e7d32;\r\n  border-color: #a5d6a7;\r\n}\r\n\r\n.status_failed {\r\n  background: #ffebee;\r\n  color: #c62828;\r\n  border-color: #ef9a9a;\r\n}\r\n\r\n/* === Бейдж переноса / критичность === */\r\n\r\n.movesBadge {\r\n  display: inline-block;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  border: 1px solid transparent;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.movesZero {\r\n  background: #eceff1;\r\n  color: #455a64;\r\n  border-color: #cfd8dc;\r\n}\r\n\r\n.movesLow {\r\n  background: #fff8e1;\r\n  color: #f9a825;\r\n  border-color: #ffe082;\r\n}\r\n\r\n.movesMedium {\r\n  background: #ffe0b2;\r\n  color: #ef6c00;\r\n  border-color: #ffb74d;\r\n}\r\n\r\n.movesHigh {\r\n  background: #ffebee;\r\n  color: #c62828;\r\n  border-color: #ef9a9a;\r\n  animation: blinkHigh 1.4s infinite;\r\n}\r\n\r\n@keyframes blinkHigh {\r\n  0%   { box-shadow: 0 0 0 rgba(198, 40, 40, 0.0); }\r\n  50%  { box-shadow: 0 0 10px rgba(198, 40, 40, 0.8); }\r\n  100% { box-shadow: 0 0 0 rgba(198, 40, 40, 0.0); }\r\n}\r\n\r\n.duration,\r\n.durationInline {\r\n  font-size: 11px;\r\n  color: #666;\r\n}\r\n\r\n/* === Переключатели и фильтры === */\r\n\r\n.viewSwitch {\r\n  display: flex;\r\n  gap: 6px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.switchBtn {\r\n  background: #f9fafc;\r\n  border: 1px solid #cbd3e1;\r\n  border-radius: 6px;\r\n  padding: 6px 10px;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.switchBtn:hover {\r\n  background: #e8eaf6;\r\n}\r\n\r\n.switchBtn.active {\r\n  background: #3f51b5;\r\n  color: #fff;\r\n  border-color: #3f51b5;\r\n}\r\n\r\n.filterRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.select {\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  border: 1px solid #cbd3e1;\r\n  font-size: 13px;\r\n  background: #fff;\r\n}\r\n\r\n/* === Карточки: сетка, две колонки внутри === */\r\n\r\n.cardsWrapper {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));\r\n  gap: 12px;\r\n  max-height: calc(100vh - 240px);\r\n  overflow-y: auto;\r\n  padding-right: 6px;\r\n}\r\n\r\n.card {\r\n  border-radius: 10px;\r\n  box-shadow: 0 1px 4px rgba(0,0,0,0.1);\r\n  padding: 10px 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  transition: all 0.2s ease;\r\n  font-size: 13px;\r\n}\r\n\r\n.card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 3px 8px rgba(0,0,0,0.15);\r\n}\r\n\r\n.cardHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n}\r\n\r\n.cardNumber {\r\n  font-weight: 700;\r\n  color: #1565c0;\r\n  text-decoration: none;\r\n}\r\n\r\n.cardSubHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n}\r\n\r\n.cardGrid {\r\n  display: grid;\r\n  grid-template-columns: 1.4fr 1.2fr;\r\n  gap: 10px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.cardColLeft,\r\n.cardColRight {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.cardBody {\r\n  color: #444;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  color: #333;\r\n  font-size: 13px;\r\n}\r\n\r\n/* === Продукты === */\r\n\r\n.products {\r\n  margin-top: 4px;\r\n  padding-top: 4px;\r\n  border-top: 1px solid #e0e0e0;\r\n}\r\n\r\n.productItem {\r\n  font-size: 12px;\r\n  padding: 1px 0;\r\n  color: #555;\r\n}\r\n\r\n.productsMore {\r\n  font-size: 12px;\r\n  margin-top: 2px;\r\n  color: #888;\r\n  font-style: italic;\r\n}\r\n\r\n/* === Таймлайн справа === */\r\n\r\n.historyTitle {\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  margin-bottom: 4px;\r\n  color: #333;\r\n}\r\n\r\n.timeline {\r\n  border-left: 2px solid #cbd3e1;\r\n  padding-left: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.timelineItem {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 6px;\r\n}\r\n\r\n.timelineDot {\r\n  position: absolute;\r\n  left: -12px;\r\n  top: 5px;\r\n  width: 9px;\r\n  height: 9px;\r\n  border-radius: 50%;\r\n  background: #3f51b5;\r\n}\r\n\r\n/* цвет первого, второго и остальных маршрутов */\r\n.timelineFirst {\r\n  background: #43a047;   /* зелёный */\r\n}\r\n\r\n.timelineSecond {\r\n  background: #ffb300;   /* жёлтый */\r\n}\r\n\r\n.timelineOther {\r\n  background: #e53935;   /* красный */\r\n}\r\n\r\n.timelineContent {\r\n  background: #fafafa;\r\n  border-radius: 6px;\r\n  padding: 4px 8px;\r\n  border: 1px solid #e0e0e0;\r\n}\r\n\r\n.timelineHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 6px;\r\n}\r\n\r\n.timelineRoute {\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.timelineTime {\r\n  font-size: 11px;\r\n  color: #757575;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.timelineAction {\r\n  font-size: 12px;\r\n  color: #555;\r\n  margin-top: 2px;\r\n}\r\n\r\n.timelineMeta {\r\n  font-size: 11px;\r\n  color: #777;\r\n  margin-top: 1px;\r\n}\r\n\r\n/* === Пагинация === */\r\n\r\n.pagination {\r\n  margin-top: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  justify-content: flex-end;\r\n  font-size: 13px;\r\n}\r\n\r\n.pagination button {\r\n  padding: 4px 10px;\r\n  border-radius: 6px;\r\n  border: 1px solid #cbd3e1;\r\n  background: #f9fafc;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.pagination button:hover:not(:disabled) {\r\n  background: #e8eaf6;\r\n}\r\n\r\n.pagination button:disabled {\r\n  opacity: 0.4;\r\n  cursor: default;\r\n}\r\n\r\n/* === Ошибки / пустота / загрузка === */\r\n\r\n.error {\r\n  margin: 8px 0;\r\n  padding: 6px 10px;\r\n  background: #ffebee;\r\n  color: #c62828;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n}\r\n\r\n.noData,\r\n.loading {\r\n  color: #444;\r\n  font-size: 14px;\r\n  text-align: center;\r\n  margin-top: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapper": `HistoryPage_tableWrapper__97+wu`,
	"table": `HistoryPage_table__59yph`,
	"addr": `HistoryPage_addr__4SoXE`,
	"statusBadge": `HistoryPage_statusBadge__2dML9`,
	"status_open": `HistoryPage_status_open__raNZi`,
	"status_closed": `HistoryPage_status_closed__krWF4`,
	"status_failed": `HistoryPage_status_failed__zxlW-`,
	"movesBadge": `HistoryPage_movesBadge__HBu22`,
	"movesZero": `HistoryPage_movesZero__r50fI`,
	"movesLow": `HistoryPage_movesLow__xUE0T`,
	"movesMedium": `HistoryPage_movesMedium__L1FRv`,
	"movesHigh": `HistoryPage_movesHigh__2Qh4-`,
	"blinkHigh": `HistoryPage_blinkHigh__4NIIu`,
	"duration": `HistoryPage_duration__+BGdW`,
	"durationInline": `HistoryPage_durationInline__1adiL`,
	"viewSwitch": `HistoryPage_viewSwitch__DwWeM`,
	"switchBtn": `HistoryPage_switchBtn__K0OZr`,
	"active": `HistoryPage_active__moK0U`,
	"filterRow": `HistoryPage_filterRow__KHXhF`,
	"select": `HistoryPage_select__FuEQ5`,
	"cardsWrapper": `HistoryPage_cardsWrapper__HZsdI`,
	"card": `HistoryPage_card__pJKgM`,
	"cardHeader": `HistoryPage_cardHeader__NshLg`,
	"cardNumber": `HistoryPage_cardNumber__TwcLl`,
	"cardSubHeader": `HistoryPage_cardSubHeader__3Z71g`,
	"cardGrid": `HistoryPage_cardGrid__ShS2u`,
	"cardColLeft": `HistoryPage_cardColLeft__7AhIr`,
	"cardColRight": `HistoryPage_cardColRight__66wyO`,
	"cardBody": `HistoryPage_cardBody__k2j9V`,
	"row": `HistoryPage_row__8fSVO`,
	"products": `HistoryPage_products__EEUyl`,
	"productItem": `HistoryPage_productItem__rjs4p`,
	"productsMore": `HistoryPage_productsMore__Aecux`,
	"historyTitle": `HistoryPage_historyTitle__fl0aJ`,
	"timeline": `HistoryPage_timeline__4oIZB`,
	"timelineItem": `HistoryPage_timelineItem__xz-ge`,
	"timelineDot": `HistoryPage_timelineDot__DX-ai`,
	"timelineFirst": `HistoryPage_timelineFirst__Leklt`,
	"timelineSecond": `HistoryPage_timelineSecond__ttB3l`,
	"timelineOther": `HistoryPage_timelineOther__t4EWd`,
	"timelineContent": `HistoryPage_timelineContent__k-1Ov`,
	"timelineHeader": `HistoryPage_timelineHeader__GMYoi`,
	"timelineRoute": `HistoryPage_timelineRoute__mNldX`,
	"timelineTime": `HistoryPage_timelineTime__JtOGu`,
	"timelineAction": `HistoryPage_timelineAction__ghUgd`,
	"timelineMeta": `HistoryPage_timelineMeta__h87-f`,
	"pagination": `HistoryPage_pagination__dkT2Z`,
	"error": `HistoryPage_error__h2Sr4`,
	"noData": `HistoryPage_noData__6UScS`,
	"loading": `HistoryPage_loading__erqD5`
};
export default ___CSS_LOADER_EXPORT___;
